import { render, staticRenderFns } from "./promptBubble.vue?vue&type=template&id=5bbb322a&scoped=true"
import script from "./promptBubble.vue?vue&type=script&lang=js"
export * from "./promptBubble.vue?vue&type=script&lang=js"
import style0 from "./promptBubble.vue?vue&type=style&index=0&id=5bbb322a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbb322a",
  null
  
)

export default component.exports